import { render, staticRenderFns } from "./detalle.vue?vue&type=template&id=1b471484&scoped=true&"
import script from "./detalle.vue?vue&type=script&lang=js&"
export * from "./detalle.vue?vue&type=script&lang=js&"
import style0 from "./detalle.vue?vue&type=style&index=0&id=1b471484&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b471484",
  null
  
)

export default component.exports